import React from 'react';
import './information.css';
import BackgroundImage from '../images/childrensHospital.jpg';
import Logo from '../images/imageLogoShadow.png';
import Chat from '../images/chatColoured.png';
import About from '../images/aboutColoured.png';
import Faq from '../images/faqColoured.png';
import Tutorial from '../images/tutorialColoured.png'
import VanderWoerd from '../images/ben.jpg';
import {Link} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import Footer from '../components/Footer';

import hospitalWithOverlay from "../images/mergedLogoHospital.png"
const Information = () => {
  return (
    <div>
      <div>
        <Helmet>
          <title>Information | ENT Chatbot</title>
        </Helmet>
      </div>
      <div class="top-image">
        <div class = "background-image">
          <img src={hospitalWithOverlay} alt="Children's Hospital" class = "background" />
        </div>
      </div>
      <div class = "text-padding">
        <h1 class = "heading-text"> ENT Chatbot </h1>
        <h2 class = "body-text"> Currently, the informed consent for complex ENT surgeries, particularly those associated with significant risks, is insufficient. 
          Patients often have a difficult time obtaining all relevant information about procedures before consenting to and undergoing surgery. When discussing their 
          surgery with doctors, patients may feel too shy to ask questions, worry that their concerns are trivial or may only think of important questions after they have 
          had time to reflect on the information. Therefore, patients often consent without having sufficient understanding of the procedure and the associated risks which
          can leave critical concerns unaddressed. </h2>
          <h2 class = "body-text"> Our project focuses on designing and building a web application that will provide ENT patients with pertinent information regarding their 
            surgical operation. This platform will serve as a resource where patients can easily access relevant information regarding their procedure, including associated 
            risks and complications, expectations and post-operative care. In addition to providing static content on ENT procedures, the web application will also include a 
            chatbot, allowing patients to ask personalized, surgery-specific questions, receive accurate real-time responses, and pose follow-up questions for further clarification. 
            The development of the small language model-based chat bot will involve exploring and adapting an existing large language model, fine-tuning it with parameter efficient 
            and adapter methods, and integrating structured knowledge resources provided by Dr. Van de Woerd. </h2>
      </div>
      <div class = "interactive-boxes">
        <Link to = "/" class = "box">
          <div>
            <img src={Chat} alt="chatbot" class = "icon"/>
            <h2 class = "body-text"> Chatbot ➜ </h2>
          </div>
        </Link>
        <Link to = "/help" class = "box"> 
          <div>
            <img src={Tutorial} alt="tutorial" class = "icon" />
            <h2 class = "body-text"> Tutorial ➜ </h2>
          </div>
        </Link>
        <Link to = "/faq" class = "box">
          <div>
            <img src={Faq} alt="faq" class = "icon"/>
            <h2 class = "body-text"> Frequently Asked Questions ➜ </h2>
          </div>
        </Link>
        <Link to = "/about" class = "box"> 
          <div>
            <img src={About} alt="about us" class = "icon"/>
            <h2 class = "body-text"> About Us ➜ </h2>
          </div>
        </Link>
      </div>
      <div class = "line-index">
        <hr></hr>
      </div>
      <div class = "text-padding">
        <h1 class = "heading-text"> Zenker's Diverticulum </h1>
        <h2 class = "body-text"> Zenker’s diverticulum is a pouch that can form in the back of the throat, just above the esophagus (the tube that carries food and liquids
           to your stomach). It occurs in an area of weakness between muscles in your throat. In this pouch, food can get trapped and lead to difficulties swallowing. Over time,
           this pouch can increase in size and cause symptoms such as difficulty swallowing, food coming back into the mouth, bad breath, or even coughing while eating.  </h2>
        <h2 class = "body-text"> Common symptoms of Zenker’s diverticulum include: </h2>
        <ul>
          <li class = "list-text"> progressive dysphagia (difficulty swallowing): at first, patients may have difficulty swallowing solid objects, but as the diverticulum grows, 
            even liquids can be hard to swallow. </li>
          <li class = "list-text"> regurgitation of food: this is when food trapped in the diverticulum can be brought back into the mouth, 
            sometimes even hours after swallowing </li>
          <li class = "list-text"> noisy swallowing: many patients report a gurgling sensation or wet sounding voice after eating  </li>
          <li class = "list-text"> aspiration (inhalation of foreign material into the airways and lungs): this is when food “goes down the wrong pipe”. This can result in food
             and drinks making their way into the lungs and causing serious consequences such as aspiration pneumonia or other respiratory infections.   </li>
        </ul>
      </div>
      <div class = "line-index">
        <hr></hr>
      </div>
      <div class = "text-split-2">
        <div>
          <h1 class = "heading-text"> Our Staff </h1>
          <h2 class = "body-text"> Dr. Benjamin van der Woerd is a skilled Laryngologist practicing at McMaster University, specializing in the diagnosis and treatment of voice, 
            airway, and swallowing disorders. In addition to his clinical practice, Dr. van der Woerd is actively involved in research and education, contributing to advancements 
            in laryngology. He works closely with multidisciplinary teams at McMaster University to offer comprehensive care for patients, ensuring that each individual receives 
            the most appropriate treatment plan tailored to their specific needs. </h2>
          <h2 class = "body-text"> Dr. van der Woerd is committed to providing exceptional care while also empowering patients with the knowledge to understand their conditions
            and treatment options fully. His approach combines the latest advancements in medical technology with a compassionate, patient-focused philosophy. </h2>
          <form action = "/about"> 
            <button class = "button" type = "submit"> Learn More ➜ </button>
          </form>
        </div>
        <div class = "text-split-image">
          <img src={VanderWoerd} alt="Dr. van der Woerd" width = "70%"/>
        </div>
      </div>
      <div class = "line-index">
        <hr></hr>
      </div>
      <div class = "text-padding">
        <h1 class = "heading-text"> Treatment Options </h1>
        <h2 class = "body-text"> Dysphagia is one indication for treatment of Zenker’s diverticulum. Weight loss and aspiration pneumonia are other indications for treatment as 
          they directly affect physical health. The aim of the treatment is to improve the mechanics, quality, and safety of swallowing. </h2>
        <h2 class = "body-text"> The treatment of Zenker’s diverticulum is surgical and can be done through either endoscopic or open approaches. </h2>
      </div>
      <div class = "non-interactive-boxes">
        <div class = "box-text">
          <h1 class = "box-heading"> Endoscopic Approach </h1>
          <h2 class = "body-text"> Endoscopic treatment is a minimally invasive procedure as it involves no external incisions. The surgeon will use a camera that goes through 
            your mouth to reach the diverticulum. Both approaches require general anesthesia, meaning you will be asleep during the procedure and will not feel anything during 
            the procedure. </h2>
        </div>
        <div class = "box-text">
          <h1 class = "box-heading"> Open Approach </h1>
          <h2 class = "body-text"> Open surgery involves making a small incision (of about 3-4 cm) on the left side of the neck to access the pouch directly. During this procedure,
             the surgeon will remove the pouch that has formed in your throat. For this procedure, you will be given general anesthesia. You will be asleep and will not feel anything
              during the procedure. </h2>
        </div>
      </div>
      <div class = "line-index">
        <hr></hr>
      </div>
      <div class = "text-padding">
        <h1 class = "heading-text"> Post-Operative Care </h1>
        <h2 class = "body-text"> Immediate-post surgery care will involve overnight hospital stay. This will allow your doctor to closely monitor you for any early signs of 
          complications like bleeding or infection. A drain may be placed in your neck to help remove any excess fluid and prevent swelling. You might also have a tube (called 
          a nasogastric tube) inserted through your nose into your stomach. This will serve as the method of feeding you so that you won’t have to use your throat right away as 
          it heals. </h2>
        <h2 class = "body-text"> On the first day after surgery, your doctor will do a swallow study with a material called Gastrografin to check if there are any leaks from the
           surgery site in your throat. This study involves drinking a solution of Gastrografin, which coats the esophagus and throat. If there are no leaks found, you will start 
           feeding with clear liquids, like water or broth. You’ll slowly move to soft foods by the end of the same day, and you might be able to go home by the end of that day. 
           If the X-ray shows a small leak, you will continue to be fed through the nasogastric tube for about a week while the area heals. Another swallow study will be done after 
           7 days to reassess the situation and determine if it is possible to move to a soft food diet. If there is a large leak, you may need another immediate surgery to fix the 
           problem. Your surgeon will clean the area and close the leak before restarting the healing process.   </h2>
      </div>
      <Footer/>
    </div>
  );
};

export default Information;